
import { defineComponent } from "vue";

export default defineComponent({
  name: "DashboardRegistrationsRowSkeleton",
  setup() {
    return {};
  },
});
